import { SvgIconLink } from "./SvgIconLink";

export class ArrowRoundLink extends SvgIconLink {
    public cssClassName: string = "null";

    protected get svgIcon() {
        return (
            <svg width="16.619" height="10.733" viewBox="0 0 16.619 10.733">
                <path
                    d="M7.431,10.367.366,3.3a1.242,1.242,0,0,1,0-1.761L1.54.366A1.242,1.242,0,0,1,3.3.366L8.309,5.374,13.317.366a1.242,1.242,0,0,1,1.761,0L16.253,1.54a1.242,1.242,0,0,1,0,1.761L9.187,10.367a1.235,1.235,0,0,1-1.756,0Z"
                    fill="#dc2765"
                />
            </svg>
        );
    }
}
